import { render, staticRenderFns } from "./ChooseCommentsAutocomplete.vue?vue&type=template&id=f327d840"
import script from "./ChooseCommentsAutocomplete.vue?vue&type=script&lang=js"
export * from "./ChooseCommentsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports